"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OperatingSystem = {
    get userAgent() {
        return navigator.userAgent;
    },
    isWindows: function (userAgent) {
        if (userAgent === void 0) { userAgent = this.userAgent; }
        return /Windows/.test(userAgent);
    },
    isMac: function (userAgent) {
        if (userAgent === void 0) { userAgent = this.userAgent; }
        return /(Mac_PowerPC)|(Macintosh)/.test(userAgent);
    },
    isLinux: function (userAgent) {
        if (userAgent === void 0) { userAgent = this.userAgent; }
        return /(Linux)|(X11)/.test(userAgent);
    },
};
exports.default = OperatingSystem;
//# sourceMappingURL=operating_system.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/operating_system.js
// module id = kD32
// module chunks = 20 21